import { useMutation, useQueryClient } from "@tanstack/react-query";

import { postModules, type SaveModuleRequest } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export function useCreateModuleMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse((request: SaveModuleRequest) =>
      postModules(request),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["MODULES_QUERY"],
      });
    },
  });
}
